export * from "./label-config.view";
